import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'angular2-cookie';
import { LoginService } from 'src/app/services/login/login.service';

declare var $: any;

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
})
export class NavBarComponent implements OnInit {
  // * ids Local Storage
  userIdLS = localStorage.getItem('userId');
  userRoleIdLS = localStorage.getItem('userRoleId');

  constructor(
    private router: Router,
    private logInService: LoginService,
    private cookie: CookieService
  ) {}

  ngOnInit(): void {
    if (this.userIdLS != null) {
      console.log(this.userIdLS);
    } else {
      // reedirigir a login
      this.router.navigate(['/login']);
    }

    $(document).ready(() => {
      // Add active state to sidbar nav links
      const path = window.location.href; // because the 'href' property of the DOM element is the absolute path
      $('#layoutSidenav_nav .sb-sidenav a.nav-link').each(function () {
        if (this.href === path) {
          $(this).addClass('active');
        }
      });

      // Toggle the side navigation
      $('#sidebarToggle').on('click', (e) => {
        e.preventDefault();
        $('body').toggleClass('sb-sidenav-toggled');
      });
    });
  }

  logOut = () => {
    this.logInService.logout(this.userIdLS).subscribe((res) => {
      // localStorage.removeItem('userId');
      // localStorage.removeItem('userRoleId');
      // localStorage.removeItem('idEmpresa');
      // localStorage.removeItem('userToken');
      // localStorage.clear();
      if (res) {
        this.cookie.put('Bearer_auth', '');
        localStorage.setItem('username', '');
        localStorage.setItem('userId', '');
        localStorage.setItem('userRoleId', '');
        localStorage.setItem('idEmpresa', '');
        localStorage.setItem('userToken', 'false');
        this.router.navigate(['/login']);
      }

      if (res.Error === 'Please authenticate') {
        this.router.navigate(['/login']);
      }
    });
  };
}
